import styled from 'styled-components';

type ButtonSimpleDivType = {
    width: string | number;
    cursor: string;
    hasHoverEffects: boolean;
    isOver: boolean;
    onHoverBackgroundColor: string;
    backgroundColor: string;
    onHoverColor: string;
    padding: string | number;
};

export const ButtonSimpleDiv = styled.div<ButtonSimpleDivType>`
    width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};
    height: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};
    cursor: ${({ cursor }) => cursor};
    padding: ${({ padding }) => (typeof padding === 'string' ? padding : `${padding}px`)};
    background-color: ${({ hasHoverEffects, isOver, onHoverBackgroundColor, backgroundColor }) =>
        hasHoverEffects && isOver ? onHoverBackgroundColor : backgroundColor};
    display: inline-block;
    outline: none;

    &:focus {
        outline: ${({ onHoverColor }) => `solid ${onHoverColor}`};
    }
`;
